'use client';

import React from 'react';
import {
  ContactFormFields,
  ContactInformation,
  ContactInfoSidebar,
  FormSubmissionResult,
  useContactForm,
  useHubSpotFormFields,
} from '@workspace/widgets';
import { Typography } from '@workspace/ui/common';
import { HeadlineRenderer } from '@workspace/widgets';
import type { HeadlineData } from '@workspace/interfaces';

export function ClientContactUsPage({
  headlineBlock,
  contactFormHeadline,
  globalSettings,
  formId,
  thankYouMessage,
}: {
  headlineBlock?: HeadlineData;
  contactFormHeadline?: string;
  globalSettings?: ContactInformation;
  formId: string;
  thankYouMessage?: string;
}) {
  const { fields, loading: fieldsLoading, error } = useHubSpotFormFields(formId);
  const {
    form,
    loading: submitting,
    result,
    showForm,
    handleMessageChange,
    handleInvalidSubmit,
    onSubmit,
  } = useContactForm({
    formId,
    fields: fields.length > 0 ? fields : undefined,
    thankYouMessage,
  });

  if (error) {
    return (
      <div className="font-openSans">
        {contactFormHeadline && showForm && (
          <Typography variant="h3" className="pb-md md:pb-2xl" styleVariant="h3">
            {contactFormHeadline}
          </Typography>
        )}
        <Typography variant="bodyMd" className="text-error">
          {error}
        </Typography>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      {headlineBlock && <HeadlineRenderer block={headlineBlock} />}

      <div className="wrapper mx-auto px-md lg:px-full-banner py-lg lg:py-2xl">
        {/* Main Title */}
        {showForm && (
          <Typography variant="h3" className="pb-md md:pb-2xl" styleVariant="h3">
            {contactFormHeadline}
          </Typography>
        )}

        {!result ? (
          <div className="flex flex-col lg:flex-row lg:gap-3xl gap-lg">
            <ContactFormFields
              form={form}
              loading={fieldsLoading}
              submitting={submitting}
              onMessageChange={handleMessageChange}
              onSubmit={onSubmit}
              onInvalidSubmit={handleInvalidSubmit}
              showForm={showForm}
              fields={fields.length > 0 ? fields : undefined}
            />

            <div className="pt-md lg:pt-0 pb-22 lg:pb-0">
              <ContactInfoSidebar
                address={globalSettings?.address}
                phone={globalSettings?.phone}
                fax={globalSettings?.fax}
              />
            </div>
          </div>
        ) : (
          <div className="flex flex-col lg:flex-row justify-between">
            <FormSubmissionResult result={result} />

            <div className="pt-md md:pt-0 pb-22 md:pb-0">
              <ContactInfoSidebar
                address={globalSettings?.address}
                phone={globalSettings?.phone}
                fax={globalSettings?.fax}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
